var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.2 15.834V10.8H4.167a.8.8 0 0 1 0-1.6H9.2V4.167a.8.8 0 0 1 1.6 0V9.2h5.034l.08.004a.8.8 0 0 1 0 1.592l-.08.004H10.8v5.034a.8.8 0 0 1-1.6 0"
})));
SvgPlus.displayName = "SvgPlus";
export { SvgPlus as ReactComponent };
export default SvgPlus;